<template>
  <div>
    <div class="flex flex-col">
      <div class="min-h-screen flex flex-col">
        <div class="md:flex bg-gray-600">
          <div class="flex flex-wrap sm:flex-nowrap justify-center sm:justify-between mx-auto w-full max-w-9xl px-6">
            <div class="mx-4 justify-center flex my-5 sm:my-0 sm:mt-1 py-1">
              <inertia-link :href="route('dashboard.show')" v-if="$page.props.auth.user">
                <img src="/images/logo.png" class="h-10" alt="Casa Auto">
              </inertia-link>
              <img src="/images/logo.png" class="h-10" alt="Casa Auto" v-else>
            </div>
          </div>
        </div>
        <div class="flex flex-grow justify-center bg-gray-200">
          <div class="w-full max-w-9xl flex flex-col">
            <flash-messages/>
            <div class="bg-white flex justify-center shadow">
              <inertia-link :href="route('jobs.show', {jobUuid: $page.props.job.uuid})" :class="isUrl(route('jobs.show', {jobUuid: $page.props.job.uuid})) ? 'text-coral-400' : 'text-white hover:text-coral-400'" class="mx-4 py-3 text-gray-600">
                {{ __("Details") }}
              </inertia-link>

              <inertia-link :href="route('jobConversation.show', {jobUuid: $page.props.job.uuid})" :class="isUrl(route('jobConversation.show', {jobUuid: $page.props.job.uuid})) ? 'text-coral-400' : 'text-white hover:text-coral-400'" class="mx-4 py-3 text-gray-600">
                {{ __("Conversation") }}
              </inertia-link>
            </div>
            <slot/>
          </div>
        </div>
        <div class="flex justify-center bg-gray-600">
          <div class="w-full max-w-9xl p-6 text-white">
            Tester Group
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Logo from '@/Shared/Logo';
  import FlashMessages from '@/Shared/FlashMessages';

  export default {
    components: {
      Logo,
      FlashMessages,
    },
    props: {
      title: String,
    },
    watch: {
      title(title) {
        this.updatePageTitle(title)
      },
    },
    mounted() {
      this.updatePageTitle(this.title);
    },
    methods: {
      updatePageTitle(title) {
        document.title = title ? `${title} | ${this.$page.props.app.name}` : this.$page.props.app.name
      },
    },
  }
</script>
